module.exports = __webpack_public_path__ + "static/img/i106.13a2899a.png";